// History
export const INITIAL_RESERVATION_HISTORY = "INITIAL_RESERVATION_HISTORY";
export const INITIAL_BRANDS = "INITIAL_BRANDS";

// Form
export const INITIAL_RESERVATION = "INITIAL_RESERVATION";
export const CHANGE_NAME = "CHANGE_NAME";
export const CHANGE_PHONE = "CHANGE_PHONE";
export const CHANGE_PAX = "CHANGE_PAX";
export const CHANGE_NOTES = "CHANGE_NOTES";
export const CHANGE_DATE = "CHANGE_DATE";

export const CHANGE_CUSTOMER_TYPE = "CHANGE_CUSTOMER_TYPE";
export const CUSTOMER_TYPE = "CUSTOMER_TYPE";
export const CHANGES_TIME = "CHANGES_TIME";
export const ERROR_PAX = "ERROR_PAX";
export const ERROR_TYPE= "ERROR_TYPE";
export const ERROR_NOTES = "ERROR_NOTES";
export const ERROR_DATE = "ERROR_DATE";
export const ERROR_TIME = "ERROR_TIME";
export const RESET_ERROR = "RESET_ERROR";
export const SUBMIT_REQUEST = "SUBMIT_REQUEST";
export const ACCEPT_TIME = "ACCEPT_TIME";
export const ACCEPT_TYPE = "ACCEPT_TYPE";
export const CHECK_CUSTOMER_TYPE = "CHECK_CUSTOMER_TYPE";

export const CANCEL_TYPE = "CANCEL_TYPE";
export const CANCEL_TIME = "CANCEL_TIME";
export const CANCEL_SUBMISSION = "CANCEL_SUBMISSION";
export const ACCEPT_SUBMISSION = "ACCEPT_SUBMISSION";
export const SUBMIT_ONPROGRESS = "SUBMIT_ONPROGRESS";
export const CLOSE_TNC = "CLOSE_TNC";
export const CLOSE_ERROR = "CLOSE_ERROR";
export const PAYMENT_DECISION = "PAYMENT_DECISION";
export const RESET = "RESET";